/**
 * 小程序广告
 */
import { MINIAPPADLIST } from '../types';

export default {
    name: `${MINIAPPADLIST}`,
    path: '/miniAppAdList',
    component: () => import(/* webpackChunkName: 'miniAppAdList' */ '@/views/miniAppAdList/'),
    redirect: { name: `${MINIAPPADLIST}Index` },
    meta: {
        title: '小程序广告',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${MINIAPPADLIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'miniAppAdList' */ '@/views/miniAppAdList/home/Home.vue'),
        },
        // 广告详情
        {
            name: `${MINIAPPADLIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'miniAppAdListDetail' */ '@/views/miniAppAdList/detail/Detail.vue'),
        },
        // 创建广告
        {
            name: `${MINIAPPADLIST}Create`,
            path: 'create',
            component: () => import(/* webpackChunkName: 'miniAppAdListCreate' */ '@/views/miniAppAdList/create/Create.vue'),
        },
        // 编辑广告投放范围
        {
            name: `${MINIAPPADLIST}Scope`,
            path: 'scope',
            component: () => import(/* webpackChunkName: 'miniAppAdListScope' */ '@/views/miniAppAdList/scope/Scope.vue'),
        },
    ],
};
